import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useParams } from 'react-router-dom';

import { ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS } from 'lib/enums/AttributePropagationFlagTypeEnum';
import { GLOBAL_VENDOR_UPDATE_FLAGS } from 'lib/networking/endpoints';
import { SwalToast } from 'lib/utils/toast';
import usePost from 'lib/hooks/usePost';

function AttributePropagationFlagDropdown({ attributePropagationFlag }) {
  const { vendorID } = useParams();
  const [attributePropagationFlagType, setAttributePropagationFlagType] = useState(
    attributePropagationFlag || null,
  );
  const { postData: update } = usePost(
    GLOBAL_VENDOR_UPDATE_FLAGS,
    () => SwalToast('success', `Successfully Updated`),
    () => SwalToast('error', `Error Occurred`),
  );
  return (
    <>
      <Row>
        <Col sm="4">
          <Form.Group>
            <Form.Label>Select Attribute Propagation Flag</Form.Label>
            <Select
              options={ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS}
              value={ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS.find(
                op => op.value === attributePropagationFlagType,
              )}
              onChange={option => {
                setAttributePropagationFlagType(option.value || null);
                update({
                  fsa_global_vendor_id: vendorID,
                  attribute_propagation_flag: option.value,
                });
              }}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}

AttributePropagationFlagDropdown.propTypes = {
  attributePropagationFlag: PropTypes.string,
};

export default AttributePropagationFlagDropdown;
